import {CleoConversationMessageTool} from '@/types/ai/cleoConversationMessageTool';
import type {CleoConversationMessageToolData} from '@/types/ai/cleoConversationMessageTool';

export interface CleoMessageErrorMeta {
    retryable?: boolean;
    retry_after_seconds?: number | null;
    [key: string]: unknown;
}

export class CleoConversationMessage {
    public id: number | null;
    public cleo_conversation_id: number | null;
    public role: string;
    public content: string;
    public error_code: string | null;
    public error_meta: CleoMessageErrorMeta | null;
    public model_name: string | null;
    public input_tokens: number | null;
    public output_tokens: number | null;
    public cached_tokens: number | null;
    public cost: number | null;
    public created_at?: Date | null;
    public tools?: CleoConversationMessageTool[];

    constructor(data?: CleoConversationMessageData) {
        if (data === undefined) {
            this.id = null;
            this.cleo_conversation_id = null;
            this.role = '';
            this.content = '';
            this.error_code = null;
            this.error_meta = null;
            this.model_name = null;
            this.input_tokens = null;
            this.output_tokens = null;
            this.cached_tokens = null;
            this.cost = null;
        } else {
            this.id = data.id;
            this.cleo_conversation_id = data.cleo_conversation_id;
            this.role = data.role;
            this.content = data.content;
            this.error_code = data.error_code ?? null;
            this.error_meta = data.error_meta ?? null;
            this.model_name = data.model_name ?? null;
            this.input_tokens = data.input_tokens ?? null;
            this.output_tokens = data.output_tokens ?? null;
            this.cached_tokens = data.cached_tokens ?? null;
            this.cost = data.cost !== undefined && data.cost !== null ? Number(data.cost) : null;
            this.created_at = data.created_at ? new Date(data.created_at) : null;
            this.tools = (data.tools ?? []).map(t => new CleoConversationMessageTool(t));
        }
    }
}

export type CleoConversationMessageData = {
    id: number | null;
    cleo_conversation_id: number | null;
    role: string;
    content: string;
    error_code: string | null;
    error_meta: CleoMessageErrorMeta | null;
    model_name: string | null;
    input_tokens: number | null;
    output_tokens: number | null;
    cached_tokens: number | null;
    cost: number | null;
    created_at: string | null;
    tools?: CleoConversationMessageToolData[];
}
